<template>
  <div> 
  </div>
</template>

<script>
  export default {
      data(){
          return{

          }
      },
      methods: {
          
      },
      components: {
          
      },
  }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/manager/components/Analyticstatistics.vue